const DefaultMapping = ({ document, information }) => {
  const sumZklZakl = information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0.21))[0]?.base?.amount;
  const sumDphZakl = information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0.21))[0]?.tax?.amount;
  const sumCelkZakl = information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0.21))[0]?.total?.amount;
  const sumZklSniz = information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0.15))[0]?.base?.amount;
  const sumDphSniz = information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0.15))[0]?.tax?.amount;
  const sumCelkSniz = information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0.15))[0]?.total?.amount;
  const sumZklSniz2 = information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0.10))[0]?.base?.amount;
  const sumDphSniz2 = information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0.10))[0]?.tax?.amount;
  const sumCelkSniz2 = information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0.10))[0]?.total?.amount;
  let sumOsv = information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0))[0]?.total?.amount
    || information('invoice.tax-amounts')?.filter((tax) => (tax.rate === 0))[0]?.base?.amount;

  const vatInvoice = !!sumZklZakl
    || !!sumDphZakl
    || !!sumCelkZakl
    || !!sumZklSniz
    || !!sumDphSniz
    || !!sumCelkSniz
    || !!sumZklSniz2
    || !!sumDphSniz2
    || !!sumCelkSniz2
    || !!sumOsv;

  // Exempted VAT amount fallbacks to total amount for no VAT invoices
  if (!vatInvoice) {
    sumOsv = information('invoice.amounts.total').number;
  }

  // Rounding amount has to be included within exempted VAT amount
  const rounding = parseFloat(information('invoice.amounts.rounding')?.number);
  if (vatInvoice && rounding > 0) {
    sumOsv = (parseFloat(sumOsv) || 0) + rounding;
  }

  return {
    id: [
      `ext:DM:${document.id}`,
    ],
    cisDosle: information('invoice.invoice-id'),
    typDokl: 'code:FAKTURA',
    popis: information('invoice.invoice-subject'),
    datVyst: document.createdAt,
    duzpPuv: information('invoice.dates.tax'),
    datSplat: information('invoice.dates.due') || information('invoice.dates.issue'),
    mena: `code:${information('invoice.amounts.total').unit}`,
    sumCelkem: information('invoice.amounts.total').number,
    sumZklZakl,
    sumDphZakl,
    sumCelkZakl,
    sumZklSniz,
    sumDphSniz,
    sumCelkSniz,
    sumZklSniz2,
    sumDphSniz2,
    sumCelkSniz2,
    sumOsv,
    zbyvaUhradit: information('invoice.amounts.due')?.number,
    zbyvaUhraditMen: information('invoice.amounts.due')?.unit,
    juhSum: information('invoice.amounts.paid')?.number,
    juhSumMen: information('invoice.amounts.paid')?.unit,
    buc: information('invoice.payment-information.bank-accounts.account-number'),
    smerKod: `code:${information('invoice.payment-information.bank-accounts.bank-number')}`,
    iban: information('invoice.payment-information.bank-accounts.iban'),
    bic: information('invoice.payment-information.bank-accounts.bic'),
    varSym: information('invoice.payment-information.variable-symbol'),
    konSym: information('invoice.payment-information.constant-symbol') ? `code:${information('invoice.payment-information.constant-symbol')}` : null,
    specSym: information('invoice.payment-information.specific-symbol'),
    nazFirmy: information('invoice.parties.sender.name'),
    firma: `vatid:${information('invoice.parties.sender.vat-id')}`,
    ic: information('invoice.parties.sender.business-id'),
    dic: information('invoice.parties.sender.vat-id'),
    bezPolozek: true,
  };
};

export default DefaultMapping;
